var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.548 25.0397H11.9565V16.6943H14.548V25.0397ZM13.2508 15.5559C12.4221 15.5559 11.75 14.8696 11.75 14.0409C11.75 13.6428 11.9081 13.2611 12.1896 12.9796C12.471 12.6982 12.8528 12.54 13.2508 12.54C13.6489 12.54 14.0306 12.6982 14.3121 12.9796C14.5935 13.2611 14.7517 13.6428 14.7517 14.0409C14.7517 14.8696 14.0792 15.5559 13.2508 15.5559ZM24.2472 25.0397H21.6613V20.9773C21.6613 20.0091 21.6417 18.7674 20.3139 18.7674C18.9665 18.7674 18.76 19.8193 18.76 20.9075V25.0397H16.1713V16.6943H18.6568V17.8327H18.6931C19.0391 17.177 19.8842 16.4851 21.1451 16.4851C23.7679 16.4851 24.25 18.2122 24.25 20.4555V25.0397H24.2472Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.79004,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(10.5 11.29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.89c080b3a0ef1a80244d963186b94e59.svg";
export { ForwardRef as ReactComponent };